import React from 'react';

import {SAMPLE_TYPES_URL} from 'sample-types/network/SampleTypeDAO';
import * as SidebarConstants from 'sidebar/SidebarConstants';
import SidebarItem from 'sidebar/SidebarItem';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function SampleTypesSettings({section}: {section: SidebarConstants.Section}): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Sample Types</div>
      <SidebarItem
        active={section === SidebarConstants.Section.SAMPLE_TYPES}
        icon={<BenchlingIcon className="result-icon" icon="sample" />}
        name="Sample types"
        link={SAMPLE_TYPES_URL}
      />
    </div>
  );
}
